<itb-checkbox [isChecked]="isSelected" [isReactive]="false" (onChangeHandler)="nameHandler($event)"></itb-checkbox>
